<div class="pt-4">
  <!-- Title -->
  <label class="block mt-5 mb-3 font-bold font-accent md:mt-6 text-md kiosk:text-2.5xl kiosk:mb-10"
    >{{
      title()
        | translateField
          : {
              defaultTranslationKey: 'cart-funnel.seatCount.title',
            }
    }}
    @if (required()) {
      <span>&#42;</span>
    }
  </label>

  <!-- Number display and keyboard -->
  <div class="kiosk:mt-8">
    <!-- Display current input -->
    <div
      class="notranslate py-4 text-center font-brand text-5xl kiosk:text-7xl font-bold text-neutral-800 mb-4"
    >
      {{ keyboardInput() || '–' }}
    </div>

    <!-- Numeric keyboard -->
    <div class="grid grid-cols-3 gap-3 max-w-md mx-auto">
      @for (key of keypadLayout; track key) {
        <button
          type="button"
          (click)="handleKeyPress(key)"
          [ngClass]="{
            'bg-yellow-200 text-2xl text-yellow-800': key === '<',
            'bg-red-200 text-red-800 text-xs': key === 'EFFACER',
            'bg-neutral-50 text-neutral-800 text-3xl': key !== '<' && key !== 'EFFACER',
          }"
          class="h-16 kiosk:h-24 rounded shadow-sm transition-all duration-100 active:scale-95 active:bg-neutral-300 font-bold"
        >
          {{ key }}
        </button>
      }
    </div>
  </div>
</div>
